import { query_order_used_record_list } from '@/api/mjstore-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/views/mjstore/orderusedrecord/mjstore-orderusedrecord-config';

import { reactive } from 'vue';

const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org

const search_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'input',
      name: 'order_code',
      label: '耗单号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写耗单号',
    },
    {
      type: 'remotemodal',
      name: 'project_id',
      label: '项目名称',
      disabled: false,
      placeholder: '请选择项目名称',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-project',
    },
    {
      type: 'remotemodal',
      name: 'customer_id',
      label: '会员姓名',
      disabled: false,
      placeholder: '请选择会员姓名',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-customer',
    },
    {
      type: 'remotemodal',
      name: 'staff_id',
      label: '执行人',
      disabled: false,
      placeholder: '请选择执行人',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-staff',
    },
    {
      type: 'remotemodal',
      name: 'card_id',
      label: '卡',
      disabled: false,
      placeholder: '请选择卡',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-card',
    },
    {
      type: 'remoteselect',
      name: 'shop_id',
      label: '执行门店',
      disabled: true,
      placeholder: '请选择执行门店',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-shop',
    },
    {
      type: 'remoteselect',
      name: 'bed_id',
      label: '床位',
      disabled: false,
      placeholder: '请选择床位',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-bed',
    },
    {
      type: 'datepicker',
      name: 'date',
      label: '耗单日期',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      format: 'YYYY-MM-DD HH:mm:ss',
      valueFormat: 'YYYY-MM-DD HH:mm:ss',
      showTime: true,
      placeholder: '请选择耗单日期',
    },
    {
      type: 'remotemodal',
      name: 'delete_staff_id',
      label: '作废执行人',
      disabled: false,
      placeholder: '请选择作废执行人',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-staff',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    order_code: null,
    project_id: null,
    customer_id: null,
    staff_id: null,
    card_id: null,
    shop_id: null,
    bed_id: null,
    date: null,
    is_delete: null,
    delete_staff_id: null,
  }),
};
const search_options = {
  is_delete: [
    { value: None, name: '全部' },
    { value: True, name: '已作废' },
    { value: False, name: '未作废' },
  ],
};

const edit_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
  },
  fields: [],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
  }),
};
const edit_model_config_options = {};

const update_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
  },
  fields: [],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
  }),
};
const update_model_config_options = {};

const titleList = {
  title: '耗单记录管理',
  addModalTitle: '新建耗单记录',
  updateTitle: '修改耗单记录',
  is_create: false, // 是否有【新建】按钮
  is_update: false, // 是否有【修改】按钮
  is_remove: false, // 是否有【删除】按钮
  is_recover: false, // 是否有【恢复】按钮
};

const api_fields: Record = {
  update: {
    id: 'id',
  },
  delete: {
    id: 'id',
  },
  recover: {
    id: 'id',
  },
  updateData: {
    org_id: 'org_id',
    id: 'id',
  },
};

const baseColumns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 50,
    fixed: 'left',
    slots: { customRender: 'index' },
  },
  {
    title: '耗单号',
    width: 150,
    dataIndex: 'order_code',
    fixed: 'left',
    checked: true,
  },
  {
    title: '订单号',
    width: 150,
    dataIndex: 'order_record__order_code',
    fixed: 'left',
    checked: true,
  },
  {
    title: '会员姓名',
    width: 150,
    dataIndex: 'customer__name',
    fixed: 'left',
    checked: true,
  },
  {
    title: '项目名称',
    width: 150,
    dataIndex: 'project__name',
    fixed: 'left',
    checked: true,
  },
  {
    title: '项目次数',
    width: 150,
    dataIndex: 'num',
    checked: true,
  },
  {
    title: '项目单价',
    width: 150,
    dataIndex: 'project_price',
    checked: true,
    slots: { customRender: 'round_price' },
  },
  {
    title: '项目金额',
    width: 150,
    dataIndex: 'price',
    checked: true,
    slots: { customRender: 'round_price' },
  },
  {
    title: '充值使用金额',
    width: 150,
    dataIndex: 'czje',
    checked: true,
    slots: { customRender: 'round_price' },
  },
  {
    title: '返利使用金额',
    width: 150,
    dataIndex: 'flje',
    checked: true,
    slots: { customRender: 'round_price' },
  },
  {
    title: '直接返利',
    width: 150,
    dataIndex: 'zjfl',
    checked: true,
    slots: { customRender: 'round_price' },
  },
  {
    title: '赠券使用金额',
    width: 150,
    dataIndex: 'zjje',
    checked: true,
    slots: { customRender: 'round_price' },
  },
  {
    title: '换单价差',
    width: 150,
    dataIndex: 'diff_price',
    checked: true,
    slots: { customRender: 'round_price' },
  },
  {
    title: '执行人',
    width: 150,
    dataIndex: 'staff__name',
    checked: true,
  },
  {
    title: '耗单日期',
    width: 150,
    dataIndex: 'date',
    checked: true,
    slots: { customRender: 'datetime' },
  },
  {
    title: '员工编码',
    width: 150,
    dataIndex: 'staff__code',
    checked: false,
  },
  {
    title: '所属顾问',
    width: 150,
    dataIndex: 'customer__adviser__name',
    checked: true,
  },
  {
    title: '执行门店',
    width: 150,
    dataIndex: 'shop__name',
    checked: true,
  },
  {
    title: '是否作废',
    width: 150,
    dataIndex: 'is_delete',
    checked: true,
    slots: { customRender: 'is_delete' },
    filterMultiple: false,
    filters: [
      { text: '全部', value: '' },
      { text: '已作废', value: true },
      { text: '未作废', value: false },
    ],
  },
  {
    title: '备注',
    width: 150,
    dataIndex: 'mark',
    checked: true,
  },
  {
    title: '床位编号',
    width: 150,
    dataIndex: 'bed__name',
    checked: true,
  },
  {
    title: '床位开始使用时间',
    width: 150,
    dataIndex: 'bed_start_time',
    checked: true,
    slots: { customRender: 'datetime' },
  },
  {
    title: '床位结束使用时间',
    width: 150,
    dataIndex: 'bed_end_time',
    checked: true,
    slots: { customRender: 'datetime' },
  },
  {
    title: '床位',
    width: 150,
    dataIndex: 'bed_id',
    checked: false,
  },
  {
    title: '项目ID',
    width: 150,
    dataIndex: 'project_id',
    checked: false,
  },
  {
    title: '作废时间',
    width: 150,
    dataIndex: 'delete_time',
    checked: false,
    slots: { customRender: 'datetime' },
  },
  {
    title: '执行人ID',
    width: 150,
    dataIndex: 'staff_id',
    checked: false,
  },
  {
    title: '门店ID',
    width: 150,
    dataIndex: 'shop_id',
    checked: false,
  },
  {
    title: '客户购买的卡',
    width: 150,
    dataIndex: 'order_record_id',
    checked: false,
  },
  {
    title: '卡名称',
    width: 150,
    dataIndex: 'card__name',
    checked: false,
  },
  {
    title: '卡ID',
    width: 150,
    dataIndex: 'card_id',
    checked: false,
  },
  {
    title: '客户编号',
    width: 150,
    dataIndex: 'customer__code',
    checked: false,
  },
  {
    title: '客户ID',
    width: 150,
    dataIndex: 'customer_id',
    checked: false,
  },
  {
    title: '作废人ID',
    width: 150,
    dataIndex: 'delete_staff_id',
    checked: false,
  },
  {
    title: '员工姓名',
    width: 150,
    dataIndex: 'delete_staff__name',
    checked: false,
  },
  {
    title: '创建日期',
    width: 150,
    dataIndex: 'create_time',
    checked: false,
    slots: { customRender: 'datetime' },
  },
  {
    title: '更新时间',
    width: 150,
    dataIndex: 'update_time',
    checked: false,
    slots: { customRender: 'datetime' },
  },
  {
    title: '操作',
    width: 200,
    dataIndex: 'action',
    checked: false,
    cellComponent: 'action',
    fixed: 'right',
  },
];
const newSlotList: any = [];
Object.assign(newSlotList, slotList);
newSlotList.push({
  type: 'custom',
  slotName: 'is_delete',
  field_true: '已作废',
  field_false: '未作废',
});

export default () => {
  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_order_used_record_list,
    addData: None,
    updateData: None,
    removeData: None,
    recoverData: None,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
